import script from "./icon-two-tones-shop.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-shop.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-shop.vue?vue&type=style&index=0&id=cc53d234&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cc53d234"]])

export default __exports__